// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/intent-widget/intent-widget.less
// module id = 3355
// module chunks = 0